import { render } from "./Scroll.vue?vue&type=template&id=7d73cea4"
import script from "./Scroll.vue?vue&type=script&lang=js"
export * from "./Scroll.vue?vue&type=script&lang=js"
script.render = render

export default script